<template>
   <v-container>
      <v-dialog origin="bottom" v-model="estadoComp" max-width="1200" scrollable persistent style="height: 500px;">

         <v-card>

            <v-card-title class="btn_otro">
               <v-row class="pb-3 pt-1">
                  <v-icon dark left>mdi-book-open-page-variant</v-icon> Temario de {{ parametros.datos.desc_curso }}
                  <v-spacer></v-spacer>
                  <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                        dark>fa-times</v-icon></v-btn>
               </v-row>
            </v-card-title>

            <v-card-text>

               <v-row class="py-4">
                  <v-col cols="12" class="d-flex">

                     <div>
                        <span><strong> Contenidos: <small class="pl-1 red--text"><i>( Marca el tipo de contenido )</i></small></strong></span>
                        <v-radio-group v-model="radioButtonContenido" @change="cargarRbContenidos($event)" row class="mt-0" hide-details>
                           <v-radio label="Inteligenio" :value="1"></v-radio>
                           <v-radio label="Colegio" :value="0"></v-radio>
                        </v-radio-group>
                     </div>
                     <v-spacer></v-spacer>
                     <div>
                        <span><strong> Periodos: <small class="pl-1 red--text"><i>( Marca un periodo )</i></small> </strong></span>
                        <v-radio-group v-model="radioButtonPeriodos" @change="onChangePeriodos($event)" row class="mt-0" hide-details>
                           <v-radio v-for="(option, index) in Periodos" :key="index" :label="option.nombre_periodo"
                              :value="option.id"></v-radio>
                        </v-radio-group>
                     </div>
                  </v-col>

                  <v-col cols=12>
                     <v-btn
                        small
                        :color="!showCarga ? 'success' : 'warning'"
                        class="ma-2 white--text"
                        @click="changeShowCarga()"
                        >
                      <v-icon left dark>
                        mdi-book-open-page-variant
                      </v-icon>
                      {{ !showCarga ? 'Ver carga' : 'Configura temario'  }}
                        
                    </v-btn>   
                  </v-col>

                  <v-col v-if="!showCarga">
                     <v-card outlined v-if="listCursos.length > 0">
                        <v-card-title class="text-subtitle-2 pa-2">
                           Unidades:<small class="pl-2 red--text"> <i>( Recuerda marcar la unidad para habilitar los temas )</i></small>
                        </v-card-title>
                        <v-card-text>
                           <v-row class="competencia white--text" dense v-for="(tema, indext) in listCursos"
                              :key="indext">

                              <v-col cols="1" class="d-flex justify-center align-center">
                                 <v-checkbox v-model="temascheck" @change="changeTemas(tema)" dense dark :value="tema.id_tema" hide-details></v-checkbox>                                              
                              </v-col>

                              <v-col cols="11" class="d-flex justify-start align-center">
                                 <div class="mt-1">
                                    <v-icon left small color="red">
                                       fas fa-chevron-right fa-lg
                                    </v-icon>
                                    {{ tema.nombre_tema }}                                    
                                 </div>
                              </v-col>

                              <v-col cols="12">
                                 <v-card outlined>
                                    <v-card-title class="text-subtitle-2 ml-10 pa-2">
                                       Temas
                                    </v-card-title>
                                    <v-card-text>
                                       <v-row dense class="capacidades white--text pb-1">
                                          <v-col cols="12">
                                             <v-row dense v-for="(clase, indexc) in tema.datos_clase" :key="indexc">
                                                <v-col cols="2" class="d-flex justify-center align-center">
                                                   <v-checkbox @change="changeClases(tema,clase)" :disabled="!temascheck.includes(tema.id_tema)" v-model="clasescheck" dense dark :value="clase.id_clase" hide-details>
                                                   </v-checkbox>
                                                </v-col>
                                                <v-col cols="10" class="d-flex justify-start align-center">
                                                   <div class="mt-1">
                                                      <v-icon left color="green">
                                                         fas fa-caret-right fa-lg
                                                      </v-icon>
                                                      {{ clase.nombre_clase }}
                                                   </div>
                                                </v-col>
                                             </v-row>
                                          </v-col>
                                       </v-row>
                                    </v-card-text>
                                 </v-card>
                              </v-col>
                           </v-row>
                        </v-card-text>
                     </v-card>
                     <v-card class="" v-else>
                        <v-row class="pa-4">
                           <v-col cols="12" class="text-center" v-if="loading">                              
                              <v-sheet :color="`transparent`">
                                 <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3">                      
                                 </v-skeleton-loader>
                              </v-sheet>
                           </v-col>
                           <v-col cols="12" class="text-center" v-else>  
                              <p class="">No hay datos para mostrar <small><i>( Seleciona filtros )</i></small> </p>                              
                           </v-col>    
                        </v-row>
                     </v-card>
                  </v-col>           
                  <v-col v-else>
                     <v-row class="">
                           <v-col cols="6" class="d-flex align-center"><i> - Lista de unidades y temas asignadas al curso para el docente </i> </v-col>
                           <v-col cols="6">
                              <v-text-field
                                 v-model="search"
                                 label="Buscar"
                                 class="mx-4"
                              ></v-text-field>
                           </v-col>
                        </v-row>
                     <!-- sort-by="nombre_clase" -->
                     <v-data-table
                        dense
                        :headers="headerCarga"
                        :items="listCargaCursos"
                        class="elevation-0 my-sticky-column-table"                        
                        group-by="nombre_tema"
                        show-group-by
                        :search="search"
                     >
                     <template v-slot:group.header="{items, isOpen, toggle}">
                     <th colspan="2">
                        <v-icon left @click="toggle"
                           >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                        </v-icon>
                        {{ items[0].nombre_tema }}
                     </th>
                     </template>
                     <template v-slot:item.tipo_contenido="{ item }">
                     
                        <v-chip small dark class="font-weight-black" :color="item.tipo_contenido ? 'primary': 'warning'">
                           {{ item.tipo_contenido ? 'Inteligenio': 'Colegio' }}
                        </v-chip>
                     </template>
                     <!-- <template v-slot:item.estado="{ item }">
                        {{ item.estado ? 'Activo': 'Inactivo' }}
                     </template> -->
                  </v-data-table>               
                  <!-- <v-col cols="12" class="text-center" v-else>              
                     <p class="">No hay datos para mostrar <small><i>( Seleciona filtros )</i></small> </p>                              
                  </v-col> -->               
                  </v-col>
               </v-row>

            </v-card-text>

            <v-card-actions class="justify-end">
            </v-card-actions>

         </v-card>

      </v-dialog>
   </v-container>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import axios, { API_URL } from "../../../../helpers/axios";

export default {
   name: 'modalTemario',
   props: {
      parametros: {
         type: Object,
      },
      estadoComp: {
         type: Boolean,
      },
   },
   data() {
      return {
         datoLogin: sessionStorage,
         Periodos: [],
         listCursos: [],
         listCargaCursos:[],
         search: '',
         params: {
            id_periodo: null,
            tipo_contenido: null,
            id_curso_filter: null
         },
         headerCarga: [
          { text: 'TEMA', value: 'nombre_tema'},
          { text: 'CLASE', value: 'nombre_clase',groupable: false, class: "header_datatable" },
          { text: 'PERIODO', value: 'periodo.nombre_periodo',groupable: false, class: "header_datatable" },
          { text: 'INICIO', value: 'periodo.fecha_inicio',groupable: false, class: "header_datatable" },
          { text: 'CIERRE', value: 'periodo.fecha_cierre',groupable: false, class: "header_datatable" },
          { text: 'ORIGEN', value: 'tipo_contenido',groupable: false, class: "header_datatable"},
         //  { text: 'ESTADO', value: 'estado',groupable: false, },
        ],
         showCarga:false,
         temascheck:[],
         clasescheck:[],
         radioButtonContenido: null,
         radioButtonPeriodos:null,
         loading:false,
      }
   },
   mounted() {
      this.loadMain();
   },
   watch: {
      estadoComp(e) {
         if (e) {
            this.loadMain();
         } else {
            this.limpiarCampos();
            this.showCarga = false;
         }
      },
      params: {
         handler(items) {

            if (items.id_curso_filter && items.id_periodo && items.tipo_contenido != null) {
               this.getAllTemas(Number(items.id_curso_filter), Number(items.tipo_contenido), Number(items.id_periodo))
            }else if(items.id_periodo && this.showCarga){
               this.getClaseTemario({id_periodo:items.id_periodo, id_curso_adm:this.parametros.datos.id_curso})
            }else if(items.tipo_contenido != null && this.showCarga){
               this.getClaseTemario({tipo_contenido:items.tipo_contenido,id_curso_adm:this.parametros.datos.id_curso})
            }
         },
         deep: true
      }
   },
   methods: {
      loadMain() {
         this.getAllPeriodos();       
      },
      changeShowCarga(){
         this.limpiarCampos();
         this.showCarga = !this.showCarga
         if (this.showCarga) {            
            this.getClaseTemario({id_curso_adm:this.parametros.datos.id_curso})
         }         
      },
      /** 
       _____________________________________________________
      |          MÉTODO SELECIONAR TIPO CONTENIDO         */
      async cargarRbContenidos(event) {
         this.params.tipo_contenido = event
         this.params.id_curso_filter = event == 1 ? this.parametros.datos.id_ck1_curso : this.parametros.datos.id_curso;
      },
      /** 
       ______________________________________________
      |          MÉTODO SELECIONAR PERIODO         */
      onChangePeriodos(event) {
         this.params.id_periodo = event
      },
      /** 
       _______________________________________________
      |          MÉTODO SELECIONAR PERIODOS         */
      async getAllPeriodos() {
         let params = {
            id_colegio: sessionStorage.id_colegio,
            id_anio_lectivo: sessionStorage.id_ano_lectivo,
         }
         try {
            const response = await axios.post(`/administrativo/periodo/list/`, params);
            this.Periodos = response.data.filter(item => item.id_adm_nivel == this.parametros.datos.id_nivel_adm);
         }
         catch (error) {
            console.log(error);
         }
      },
      /** 
       ______________________________________________
      |          MÉTODO OBTENER CURSO CK1          */
      async getAllTemas(id_curso_filter, tipo_contenido, id_periodo) {

         this.loading = true;
         
         this.getClaseTemario({id_periodo,tipo_contenido,id_curso_adm:this.parametros.datos.id_curso})  
         this.listCursos= [];
         try {
            const { data } = await axios.get(`/administrativo/temario/${id_curso_filter}/${tipo_contenido}`);          

            this.listCursos = data; 
            
         }  
         catch (error) {
            console.log(error);
         }finally{
            this.loading = false;
         }
      },
      /** 
       ____________________________________________
      |          MÉTODO SELECCIONAR CLASE        */
      changeClases(tema,clase){
         if (this.clasescheck.includes(clase.id_clase)) {

            let paramAdd = {
               id_clase:clase.id_clase, 
               nombre_clase:clase.nombre_clase, 
               id_tema:tema.id_tema, 
               nombre_tema:tema.nombre_tema, 
               id_periodo: this.params.id_periodo, 
               id_ano_lectivo: Number(this.datoLogin.id_ano_lectivo), 
               id_curso_adm: this.parametros.datos.id_curso, 
               id_curso_ck1: this.parametros.datos.id_ck1_curso, 
               tipo_contenido: this.params.tipo_contenido, 
               estado:1
            }
            this.addClaseTemario(paramAdd)

         }else{
            this.removeClaseTemario(clase.id_clase,this.params.tipo_contenido,this.params.id_periodo);
         }
      },
      /** 
       ____________________________________________
      |          MÉTODO SELECCIONAR CLASE        */
      changeTemas(tema){

         // eslint-disable-next-line no-empty
         if (this.temascheck.includes(tema.id_tema)) {
         }else{
            let clasesDeleting = [];
            tema.datos_clase.forEach(e => {
               clasesDeleting.push(e.id_clase)
            });
            this.clasescheck = this.clasescheck.filter(el => !clasesDeleting.includes(el));

            this.removeTodasClaseTemario(clasesDeleting,this.params.tipo_contenido,this.params.id_periodo)

         }
      },
      /** 
       ___________________________________________________
      |          MÉTODO AGREGAR CLASE A TEMARIO         */
      async getClaseTemario(queryObject) {

         this.clasescheck = [];
         this.temascheck = [];
         this.listCargaCursos = [];

         try {

            const { data } = await axios.get(`/administrativo/temario/getTemario`,{ 
               params: queryObject
            });
            
            if (data.length > 0) {

               if (!this.showCarga) {
                  data.forEach(e => {
                  if (e.tipo_contenido == this.params.tipo_contenido) {
                     this.clasescheck.push(e.id_clase)
                     if (!this.temascheck.includes(e.id_tema)) {
                        this.temascheck.push(e.id_tema);
                     }
                  }
               });
               }else{
                  this.listCargaCursos = data;
               }          
            }

         }catch (error) {
            console.log(error);
         }
      },
      /** 
       ___________________________________________________
      |          MÉTODO AGREGAR CLASE A TEMARIO         */
      async addClaseTemario(datosSave) {
         try {
            // const {data} = 
            await axios.post('/administrativo/temario/addclasestemario',datosSave);
            // console.log('de los guardado', data);
         }
         catch (error) {
            console.log(error);
         }
      },
      /** 
       ____________________________________________________
      |          MÉTODO REMOVER CLASE DE TEMARIO         */
      async removeClaseTemario(id_clase, tipo_contenido, id_periodo) {
         try {
            // eslint-disable-next-line no-unused-vars
            const { data } = await axios.delete(`/administrativo/temario/removeclasestemario/${id_clase}/${tipo_contenido}/${id_periodo}`);
         }
         catch (error) {
            console.log(error);
         }
      },
            /** 
       ____________________________________________________
      |          MÉTODO REMOVER CLASE DE TEMARIO         */
      async removeTodasClaseTemario(id_clase_array, tipo_contenido, id_periodo) {

         const idClaseArrayString = id_clase_array.join(','); 

         try {
            // const { data } = 
            await axios.delete(`/administrativo/temario/removeallclasestemario/${idClaseArrayString}/${tipo_contenido}/${id_periodo}`);
      
         }
         catch (error) {
            console.log(error);
         }
      },
      /** 
       ___________________________________________
      |          MÉTODO LIMPIAR CAMPOS          */
      limpiarCampos(){
         this.radioButtonContenido = null;
         this.radioButtonPeriodos = null;
         this.clasescheck = [];
         this.temascheck = [];
         this.listCursos = [];
         this.listCargaCursos = [];         
         this.params = {
            id_periodo: null,
            tipo_contenido: null,
            id_curso_filter: null
         }
      }
   }
}
</script>
<style scoped>
.temario-header{
  background-color: #1976D2; /* Color azul */
  color: white; /* Texto en blanco */
}
</style>